import { NgModule } from '@angular/core';
import { MyLibComponent } from './my-lib.component';
import { MyfortComponent } from './myfort/myfort.component';


@NgModule({
  declarations: [MyLibComponent, MyfortComponent],
  imports: [
  ],
  exports: [MyfortComponent, MyLibComponent]
})
export class MyLibModule { }
